import React, { useEffect, useState } from "react"
// import axios from "axios"
import $ from "jquery"
// eslint-disable-next-line no-unused-vars
import { defaultArea, apiAddressyKey } from "@common/constant"

const SearchArea = ({
  areaVal,
  setAreaInputVal,
  setShowSuggestion,
  showSuggestion,
}) => {
  const [suggestionList, setSuggestionList] = useState([])
  const [areaList, setAreaList] = useState([])

  // const getitems = async (url) => {
  //   try {
  //     const { data } = await axios.get(url, {})
  //     setSuggestionList(data.Items)
  //   } catch (error) {
  //     //   console.error(error)
  //   }
  // }

  const selectSuggestion = (item) => {
    setSuggestionList([])
    setAreaInputVal(item.area_name)
  }

  useEffect(() => {
    fetch("/property-search-areas.json").then((res) =>
      res.json().then((areas) => setAreaList(areas)),
    )
  }, [])

  const handleChange = (event) => {
    const inputValue = event.target.value
    $(".auto_suggest").removeClass("d-none")
    setAreaInputVal(inputValue)
    setShowSuggestion(true)
    // console.log("val==>", event.target.value)
    let matches = []

    if (inputValue.length > 2) {
      // const regex = new RegExp(`${inputValue}`, "gi")
      // matches = areaList.filter((item) => regex.test(item.area_name))
      matches = areaList.filter(
        (item) =>
          item.area_name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1,
      )

      setSuggestionList(matches)

      // const url = `https://api.addressy.com/StoreFinder/Interactive/FindPlaceNames/v1.10/json3.ws?Key=${apiAddressyKey}&SearchTerm=${inputValue}&MatchType=Exact&Country=UK`
      // getitems(url)
    } else {
      setSuggestionList([])
    }
  }

  // console.log("suggestionList", suggestionList.slice(0, 10))

  return (
    <>
      <input
        type="text"
        placeholder="Enter your search location"
        value={areaVal === defaultArea.toLowerCase() ? "" : areaVal}
        onChange={handleChange}
        // onBlur={() => setShowSuggestion(false)}
        // onFocus={() => setShowSuggestion(true)}
      />
      {suggestionList.slice(0, 10).length > 0 && (
        <ul className={`auto_suggest ${showSuggestion ? "" : "d-none"}`}>
          {suggestionList.slice(0, 10).map((item) => {
            return (
              <li key={item.slug} onClick={() => selectSuggestion(item)}>
                {item.area_name}
              </li>
            )
          })}
        </ul>
      )}
    </>
  )
}
export default SearchArea
